import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthStore } from '../store/auth.store';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	constructor(
		private authStore: AuthStore,
		private router: Router,
		private route: ActivatedRoute
	) {}

	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		// Modo cookie (Fase 2): el JWT es httpOnly y no se puede decodificar en cliente.
		// Si aún no hay usuario en memoria, restauramos la sesión desde el servidor con la
		// cookie (getUserFromToken → /auth/me). Si no hay sesión válida, hace logout.
		if (environment.useCookieAuth && !this.authStore.user()) {
			await this.authStore.getUserFromToken();
		}
		const isAuth = this.authStore.isAuthenticated();
		const data: any = route.data;

		const validateShouldChangePass = () => {
			const isChangePassword = state.url.startsWith('/change-password')

			if (isChangePassword && !this.authStore.user()?.metadata.shouldChangePassword) {
				this.router.navigateByUrl('/')
				return false
			} else if (isChangePassword && !this.authStore.getEncryptedPass()) {
				// Si no hay contraseña encriptada, redirigir a login en lugar de hacer logout
				// Esto permite que el usuario vuelva a ingresar su contraseña
				this.router.navigateByUrl(`/login?redirect=/change-password`)
				return false
			}
			else if (this.authStore.user()?.metadata.shouldChangePassword && !isChangePassword) {
				const redirect = state.url === '/login' ? '' : `?redirect=${state.url}`
				this.router.navigateByUrl(`/change-password${redirect}`)
				return false
			}
			return true
		}

		if (!this.authStore.user() && isAuth) {
			await this.authStore.getUserFromToken();
			return validateShouldChangePass();
		}
		if (isAuth) {
			return validateShouldChangePass()
		} else {
			const path = window.location.pathname.trim();
			if (path && path !== '/login' && path !== '/404') {
				this.router.navigateByUrl(`/login?redirect=${path}`);
			} else {
				this.router.navigateByUrl(`/login`);
			}
			return false;
		}
	}
}
